<template>
  <div class="left-menu">
    <div class="menu-list">
      <a-menu
          style="width: 200px"
          mode="inline"
          @click="menuClick"
          v-model:openKeys="state.openKeys"
          v-model:selectedKeys="state.selectedKeys"
      >
        <template v-for="item in menuList">
          <template v-if="item.children && item.children.length>0">
            <a-sub-menu :key="item.redirect||item.path">
              <template #icon>
                <component :is="item.icon"/>
              </template>
              <template #title>{{ item.title }}</template>
              <a-menu-item v-for="v in item.children" :key="v.redirect||v.path">{{ v.title }}</a-menu-item>
            </a-sub-menu>
          </template>
          <template v-else>
            <a-menu-item :key="item.redirect||item.path">
              <template #icon>
                <component :is="item.icon"/>
              </template>
              {{ item.title }}
            </a-menu-item>
          </template>
        </template>
      </a-menu>
    </div>
  </div>
</template>

<script setup>
import {onMounted, reactive, computed, watch} from "vue";
import {useStore} from "vuex";
import {useRoute, useRouter} from "vue-router";
import {arrToTree} from '@/hook/useStructureConvert'

const store = useStore()
const route = useRoute()
const router = useRouter()

const state = reactive({
  openKeys: [], // 当前展开的 SubMenu 菜单项 key 数组
  selectedKeys: [], // 当前选中的菜单项 key 数组
})

watch(() => route.path, (newPath, oldPath) => {
  let _pathList = route.path.split('/').filter(Boolean)
  let _openKeys = []
  _pathList.map((item, index) => {
    let _path = _pathList.slice(0, index + 1).join('/')
    _openKeys.push(`/${_path}`)
  })

  state.openKeys = _openKeys
  state.selectedKeys = [route.meta.sel]
}, {deep: true, immediate: true});

// 菜单列表
const menuList = computed(() => {
  let _list = []

  store.state.menu.map(item => {
    if (item.is_show === 1) {
      _list.push(item)
    }
  })
  return arrToTree(_list)
})

// 菜单点击
const menuClick = (e) => {
  router.push(e.key)
}

onMounted(() => {
})

</script>
<style lang="less" scoped></style>